import { AuthenticationService } from "@app/core/services"

export function appInitializer(authenticationService: AuthenticationService) {
    return () => new Promise(resolve => {
        //Attempt to refresh token on app start up to auto authenticate
        authenticationService.getMe()
            .subscribe()
            .add(resolve);
    })
}